import { colors } from 'theme'

export const defaultThemeStyles = {
    incoming: colors.blackLight,
    outgoing: colors.darkCloud
}
